import { createContext } from 'react';
import { OrgProjectContextType } from '@/context/OrgProjectContext/types.ts';

const OrgProjectContext = createContext<OrgProjectContextType | undefined>(undefined);

export default OrgProjectContext;
